import { SupportEmailLink } from "components/app/support-email-link";
import { ConstantContact } from "components/constant-contact";
import { ContentFull, ContentHeader } from "components/layout";
import { InlineBanner } from "components/ui/inline-banner";
import { PremiumCallout } from "components/ui/premium-callout";
import React from "react";
import { useProductName } from "store/selectors/branding";
import { useFeature } from "store/selectors/hooks";

interface ManageIntegrationsConstantContactProps {
    match?: {
        path?: string;
        params?: {
            audienceId?: string;
            subtab?: string;
            audienceTab?: string;
        };
    };
}

export const ManageIntegrationsConstantContact: React.FC<
    ManageIntegrationsConstantContactProps
> = props => {
    const isFeatureEnabled = useFeature("constantContact");
    const productName = useProductName();

    if (isFeatureEnabled) {
        return <ConstantContact match={props.match} />;
    }

    return (
        <ContentFull>
            <ContentHeader>Constant Contact</ContentHeader>
            <PremiumCallout>
                <InlineBanner type="info">
                    Constant Contact is only available on request to {productName} Premium
                    customers. <br />
                    Please{" "}
                    <SupportEmailLink
                        label="contact support"
                        subject="Constant Contact Integration"
                    />{" "}
                    to request an upgrade.
                </InlineBanner>
            </PremiumCallout>
        </ContentFull>
    );
};
